import React from 'react';

import Box from '../Box';
import { ComponentProps } from '../utils/types';
import StyledButton from './styles';
import ButtonInterface, { isAnchor } from './types';

const Button = React.forwardRef<HTMLElement, ButtonInterface>((props, ref) => {
  const { rightAddon, leftAddon, children, size, ...rest } = props;
  let typedRef:
    | React.ForwardedRef<HTMLAnchorElement>
    | React.ForwardedRef<HTMLButtonElement>;
  let wrapperTag: 'a' | 'button';
  if (isAnchor(props)) {
    typedRef = ref as React.ForwardedRef<HTMLAnchorElement>;
    wrapperTag = 'a';
  } else {
    typedRef = ref as React.ForwardedRef<HTMLButtonElement>;
    wrapperTag = 'button';
  }

  return (
    <StyledButton as={wrapperTag} sizeVariant={size} {...rest} ref={typedRef}>
      {leftAddon && (
        <Box mr={1} display="inline-flex">
          {leftAddon}
        </Box>
      )}
      {children}
      {rightAddon && (
        <Box ml={1} display="inline-flex">
          {rightAddon}
        </Box>
      )}
    </StyledButton>
  );
});

export type ButtonProps = ComponentProps<typeof Button>;
export default Button;
